import React, { useEffect, useState } from 'react';
import { Avatar, Box, Card, CircularProgress, Grid, Typography, alpha } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TaxiAlertIcon from '@mui/icons-material/TaxiAlert';
import StyleIcon from '@mui/icons-material/Style';
import PrivateWrapper from '../layouts/Private';
import { getOverview } from '../services/Dashboard';

const Home = () => {
  const [data, setData] = useState({
    totalBookings: 0,
    totalUsers: 0,
    totalExcursions: 0,
    totalAffiliates: 0,
    totalPendingAffilitesApprovals: 0,
    totalApprovedAffiliates: 0,
    totalHotelPickups: 0,
    bookingWithFailedPickupAssignment: 0,
    totalBlogs: 0,
  });
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    setDataLoaded(false);
    getOverview().then((d) => {
      setData(d);
      setDataLoaded(true);
    });
  }, []);

  return (
    <PrivateWrapper>
      <Box
        px={2}
        minHeight="80vh"
        display="flex"
        my={2}
        sx={!dataLoaded ? { alignItems: 'center', justifyContent: 'center' } : undefined}
      >
        {!dataLoaded && (
          <Box display="flex" gap={2} p={2}>
            <CircularProgress size={28} />
            <Typography>Loading...</Typography>
          </Box>
        )}
        {dataLoaded && (
          <Grid container spacing={3} alignContent="flex-start">
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                variant="outlined"
                elevation={1}
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <AirplaneTicketIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Bookings
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalBookings || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                elevation={1}
                variant="outlined"
                component={Card}
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <GroupIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Users
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalUsers || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                elevation={1}
                variant="outlined"
                component={Card}
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <CardTravelIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Excursions
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalExcursions || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                elevation={1}
                variant="outlined"
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <SupervisedUserCircleIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Total Affiliates
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalAffiliates || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                elevation={1}
                variant="outlined"
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <HowToRegIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Approved Affiliates
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalApprovedAffiliates || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                elevation={1}
                variant="outlined"
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <PendingActionsIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Pending Affiliates
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalPendingAffilitesApprovals || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                elevation={1}
                variant="outlined"
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <EmojiTransportationIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Hotel Pickups
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalHotelPickups || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                elevation={1}
                variant="outlined"
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <TaxiAlertIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Failed Pickup Assignments
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.bookingWithFailedPickupAssignment || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={4}>
              <Box
                p={3}
                component={Card}
                elevation={1}
                variant="outlined"
                display="flex"
                alignItems="center"
              >
                <Avatar
                  sx={{
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.2),
                    padding: '10px',
                    height: 'auto',
                    width: 'auto',
                  }}
                >
                  <StyleIcon fontSize="large" color="primary" />
                </Avatar>
                <Box ml="auto" display="flex" flexDirection="column" gap={2}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    Active Blogs
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" textAlign="right">
                    {data.totalBlogs || '-'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>
    </PrivateWrapper>
  );
};

export default Home;
